export const statusColor = (status) => {
  if (/REJECT|CANCEL/.test(status || "")) return "red";
  if (/APPROV|ACCEPT|COMPLET|POSTED|RECEIVED/.test(status || "")) return "green";
  if (/PENDING|REVIEW|CLARIFICATION|NEGOTIATION|AGREED/.test(status || "")) return "blue";
  return "gray";
};
